import { Box, Stack } from "@mui/system";
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Zoom,
} from "@mui/material";
import { deepOrange, grey } from "@mui/material/colors";
import { useEffect, useState } from "react";
import Create from "./Create";
import partialDelete from './PartialDelete'

function Sent(props) {
  const { setMain } = props;

  const [messages, setMessages] = useState([]);

  const sentMessages = messages.filter(msg=>{return msg.label==='sent' && !msg.deleted ?  true:false})

  useEffect(
    () => async () => {
      const response = await fetch(
        "http://127.0.0.1:8000/messenger/messages/",
        {
          mode: "cors",
          method: "GET",
        }
      );
      const fetcher = response.body.getReader();
      let data = [];
      let receivedLength = 0;
      while (true) {
        const { value, done } = await fetcher.read();

        if (done) {
          break;
        }

        data.push(value);
        receivedLength += value.length;
      }
      let chunksAll = new Uint8Array(receivedLength);
      let position = 0;
      for (let chunk of data) {
        chunksAll.set(chunk, position);
        position += chunk.length;
      }
      let result = new TextDecoder("utf-8").decode(chunksAll);

      let finalData = JSON.parse(result);
      setMessages(finalData);
      console.log(finalData);
    },
    []
  );
  

  const handleDelete = (id) => {
    const filteredMessages = messages.map((mesg) => {
      if (id === mesg.id) {
        mesg.deleted = true;
      }
      return mesg;
    });
    setMessages(filteredMessages);
    const params =  {
      url:'http://127.0.0.1:8000/messenger/messages/',
      method:'PATCH',
      params :{
        id:id,
        type:'delete',
      }
    }
    const results = partialDelete(params)
  };

  const handleResend = (text) => {
    setMain(<Create text={text} />);
  };

  return (<Zoom in={true} style={{ transitionDelay: "200ms" }}>
    <Stack>
      <Typography variant="h6">Sent</Typography>
      <Divider variant="middle" />
      {sentMessages.length>0 ? sentMessages.map((message) => {
        // const rec = message.recipient.map((recip) => {
        //   return ` ${recip.firstName}  ${recip.lastName}`;
        // });
        return (
          
          <Card elevation={3} key={message.id} sx={{ mt: 1, mb: 1 }}>
            <CardHeader
              sx={{ bgcolor: grey[200] }}
              avatar={<Avatar sx={{ bgcolor: deepOrange[500] }}>S</Avatar>}
              title={message.date}
              subheader={
                <Typography variant="h6">To : {"recipients"}</Typography>
              }
            />
            <CardContent>
              <Typography>{message.message}</Typography>
            </CardContent>
            <CardActions
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <Button variant="outlined" onClick={() => handleResend(message.message)}>
                Resend
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleDelete(message.id)}
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        );
      }) : <Box display={'flex'} justifyContent={'center'} mt={2}><Typography>No Sent Messages</Typography></Box>}
    </Stack>
    </Zoom>
  );
}

export default Sent;
